
import { useTheme } from '@mui/material/styles'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const IncidentDetails = ({ items }) => {
  const theme = useTheme()
  return (
    <Stack data-id="incident-management-incident-details-modal-tab">
      <Stack
        borderRadius='5px'
        border='1px solid'
        borderColor={theme.palette.accent.sky}
        p={3}
        flexDirection='row'
        flexWrap='wrap'
        gap={3}>
        {items?.map((item, index) => (
          <Stack
            key={`incident-details-${index}`}
            flex={1}
            minWidth='calc(100%/3)'>
            <Typography variant="bodyLarge" color={theme.palette.accent.sky}>
              {item?.label}
            </Typography>
            <Typography variant="bodyLarge">
              {item?.value}
            </Typography>
          </Stack>
        ))}

      </Stack>
    </Stack>
  )
}

export default IncidentDetails
